import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import {
    CommonFilterModel,
    CommonPaginatorResourceService,
    CommonParams
} from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { GridUtils } from '@/shared/util/grid-utils'

export class ConfigurationRateGridConceptsDatasource<T> extends PaginatorLaboratoryDatasource<T> {
    readonly rateId: number

    constructor(service: CommonPaginatorResourceService<T>, laboratoryId: number, rateId: number) {
        super(service, laboratoryId)
        this.rateId = rateId
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        const _filterModel: CommonFilterModel = {
            'rate.id': GridUtils.getNumberFilterModel('equals', this.rateId),
            ...filterModel
        }
        return this.service.paginator(_filterModel, params, this.laboratoryId)
    }
}
